export default {
  ACCESS_DENIED: 'AccessDenied',
  HUMAN_VERIFICATION_REQUIRED: 'HumanVerificationRequired',
  INVALID_REQUEST: 'InvalidRequest',
  INVALID_TRANSFER: 'InvalidTransfer',
  LIMIT_REACHED: 'LimitReached',
  RECAPTCHA_FAILED: 'RecaptchaFailed',
  TOO_MANY_RECIPIENTS: 'TooManyRecipients',
  TOO_MANY_REQUESTS: 'TooManyRequests',
  UNAVAILABLE_PARENT: 'UnavailableParent',
  UNKNOWN_RESPONSE: 'UnknownResponse',
  USER_BLOCKED: 'UserBlocked',
  VALIDATION_FAILED: 'ValidationFailed',
  WRONG_VERIFICATION_CODE: 'WrongVerificationCode',
};
